var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"pl-3 pt-3"},[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v("Manufacturer Formats")]),_c('ManageManufacturers')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }